import React, { useEffect } from "react";
import "./App.css";
import { HashRouter, Routes, Route, useParams, useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { App as CapApp } from "@capacitor/app";
import { AuthProvider } from "./context/AuthContext";
import SpotifyClone from "./SpotifyClone";
import AdminDashboard from "./pages/AdminDashboard";
import EmbedPlayer from "./pages/EmbedPlayer";
import SharePlayer from "./pages/SharePlayer";

function App() {
  useEffect(() => {
    const backendBase = process.env.REACT_APP_BACKEND_URL;
    if (!backendBase) return;
    if (document.querySelector('[data-adsense-global="true"]')) return;

    const injectAdSense = async () => {
      try {
        const response = await fetch(`${backendBase}/api/ads/adsense-script`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: "{}"
        });
        const data = await response.json();
        if (!data?.script) return;

        const temp = document.createElement("div");
        temp.innerHTML = data.script;
        const nodes = Array.from(temp.childNodes);

        if (!nodes.length) {
          const scriptEl = document.createElement("script");
          scriptEl.text = data.script;
          scriptEl.dataset.adsenseGlobal = "true";
          document.head.appendChild(scriptEl);
          return;
        }

        nodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const tag = node.tagName.toLowerCase();
          if (tag === "script") {
            const scriptEl = document.createElement("script");
            Array.from(node.attributes).forEach((attr) => {
              scriptEl.setAttribute(attr.name, attr.value);
            });
            scriptEl.text = node.textContent || "";
            scriptEl.dataset.adsenseGlobal = "true";
            document.head.appendChild(scriptEl);
          } else if (tag === "ins") {
            const insEl = node.cloneNode(true);
            insEl.dataset.adsenseGlobal = "true";
            document.head.appendChild(insEl);
          }
        });
      } catch (error) {
        console.warn("Injection AdSense échouée:", error);
      }
    };

    injectAdSense();
  }, []);
  const StoryRoute = () => {
    const { id } = useParams();
    return <SpotifyClone initialStoryId={id} />;
  };
  const DeepLinkHandler = () => {
    const navigate = useNavigate();
    useEffect(() => {
      if (!Capacitor.isNativePlatform()) return;
      const sub = CapApp.addListener('appUrlOpen', (data) => {
        const url = data?.url || '';
        if (!url) return;
        let path = '';
        try {
          const parsed = new URL(url);
          path = parsed.pathname || '';
        } catch (e) {
          path = url.replace(/^[^:]+:\/\//, '');
        }
        const matchStory = path.match(/\/(api\/share\/story|share\/story|story)\/(\d+)/);
        const matchTrack = path.match(/\/(api\/share\/track|share\/track|track)\/(\d+)/);
        let type = null;
        let id = null;
        if (matchStory) {
          type = 'story';
          id = matchStory[2];
        } else if (matchTrack) {
          type = 'track';
          id = matchTrack[2];
        }
        if (type === 'story' && id) {
          navigate(`/story/${id}`);
          return;
        }
        if (type === 'track' && id) {
          navigate(`/?playTrack=${id}`);
        }
      });
      return () => {
        if (sub && typeof sub.remove === 'function') sub.remove();
      };
    }, [navigate]);
    return null;
  };
  return (
    <AuthProvider>
      <HashRouter>
        <DeepLinkHandler />
        <Routes>
          <Route path="/" element={<SpotifyClone />} />
          <Route path="/story/:id" element={<StoryRoute />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/embed/track/:id" element={<EmbedPlayer />} />
          <Route path="/share/track/:id" element={<SharePlayer />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}

export default App;
